module.exports = __webpack_public_path__ + "static/media/cross-circle.1927c572.svg";